function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "sound_sound"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m15.332 2.577c-.522-.182-1.092.091-1.275.612-.184.521.091 1.092.611 1.275 3.189 1.12 5.332 4.149 5.332 7.536s-2.143 6.416-5.332 7.537c-.521.183-.795.754-.611 1.275.145.412.53.669.943.669.11 0 .222-.019.332-.057 3.988-1.402 6.668-5.189 6.668-9.424s-2.68-8.022-6.668-9.423z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m14.398 15.201c-.441.332-.529.959-.197 1.4.196.261.496.399.8.399.209 0 .42-.065.601-.201 1.502-1.13 2.398-2.924 2.398-4.799s-.896-3.669-2.398-4.799c-.443-.333-1.069-.243-1.4.198-.332.441-.244 1.068.197 1.4 1.002.754 1.601 1.951 1.601 3.201s-.599 2.447-1.602 3.201z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m12.383 2.076c-.375-.154-.804-.069-1.09.217l-4.707 4.707h-2.586c-1.103 0-2 .897-2 2v6c0 1.103.897 2 2 2h2.586l4.707 4.707c.191.191.447.293.707.293.129 0 .259-.025.383-.076.373-.155.617-.52.617-.924v-18c0-.404-.244-.769-.617-.924zm-1.383 16.51-3.293-3.293c-.187-.188-.442-.293-.707-.293h-3v-6h3c.265 0 .52-.105.707-.293l3.293-3.293z"
})));

var Svg114Highvolume = function Svg114Highvolume(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg114Highvolume, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/114-high volume.932f340d.svg";
export { ForwardRef as ReactComponent };